import _ from "lodash";

export const accessoryIsInstalled = (thing) => {
	return (
		thing
		&& thing.supplements
		&& thing.supplements.analog_inputs
		&& !_.isEmpty(thing.supplements.analog_inputs));
};

export const generateAccessoryList = (state) => {
	let result = [];

	result.push({
		path: "master",
		valid: accessoryIsInstalled(state.ablauf)
	});

	state.ablauf.compressors.forEach((compressor, index) => {
		result.push({
			path: index + 0,
			valid: accessoryIsInstalled(compressor)
		});
	});

	return result;
};

export const defaultAccessoryPath = (state, prefix) => {
	const list = generateAccessoryList(state);
	let index = 0;
	while (index >= 0 && index < list.length) {
		if (list[index].valid) {
			return prefix + list[index].path;
		}
		index += 1;
	}
	return null;
};

export const hasAnyAccessory = (state) => {
	return defaultAccessoryPath(state, "dummy") !== null;
};

export const accessoryIndexFromLocation = location_path => {
	let parts = location_path.split("/");
	let index = null;
	switch(parts[3]) {
	case "master":
		index = 0;
		break;
	default:
		index = Number(parts[3]) + 1;
		break;
	}
	return index;
};

export const prevInstalledAccessoryIndex = (state, location_path) => {
	const list = generateAccessoryList(state);
	let index = accessoryIndexFromLocation(location_path) - 1;
	while (index >= 0 && index < list.length) {
		if (list[index].valid) {
			return list[index].path;
		}
		index -= 1;
	}
	return null;
};

export const nextInstalledAccessoryIndex = (state, location_path) => {
	const list = generateAccessoryList(state);
	let index = accessoryIndexFromLocation(location_path) + 1;
	while (index < list.length) {
		if (list[index].valid) {
			return list[index].path;
		}
		index += 1;
	}
	return null;
};

export const statePartToAnalogInputs = (thing) => {
	if (thing.supplements !== undefined
		&& thing.supplements.analog_inputs !== undefined) {
		
		const result = [];
		for(const a in thing.supplements.analog_inputs) {
			const val = thing.supplements.analog_inputs[a];
			if (val !== null) {
				result.push(
					{
						index: a,
						name: val.name,
						function: val.function,
						value: val.value
					}
				);
			}
		}
		return result.sort((a, b) => {
			if (a.index < b.index)
				return -1;
			else if (a.index > b.index)
				return 1;
			return 0;
		});
	}
	return [];
};